/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { FC } from "react"
import { BodySmall } from "components/views/atoms/Bodies"
import { TextLink } from "components/views/atoms/links/TextLink"
import { FormattedMessage } from "react-intl"
import { RegistrationFlowLayout } from "./RegistrationLayouts"

const RegisterError: FC = () => (
  <RegistrationFlowLayout
    header={<FormattedMessage defaultMessage="Something’s not working" />}
    description={
      <>
        <BodySmall color="black-80">
          <FormattedMessage
            defaultMessage="We weren't able to activate your account. Try clicking the unique 
      activation link in your email. Still not working? Contact us at <link>support@get-carrot.com</link>."
            values={{
              link: (text) => (
                <TextLink underlineColor="black-80" to="mailto:support@get-carrot.com">
                  {text}
                </TextLink>
              )
            }}
          />
        </BodySmall>
      </>
    }
  />
)

export { RegisterError }
